import {useContext, MutableRefObject, useEffect, useState} from 'react';
import {useTypedFastStorage} from '../../../hooks/useFastStorage';
import {IGeneralWithList} from "../../../ifmsTypes";
import { ApplicableTableSettings } from '../../../tableSettings';
import SecondaryButton from "../../../ui/SecondaryButton";
import SmartTable from '../../../uiControls/SmartTable';
import { adjustBalanceTable } from './reportTableSettings/reportTableSettings';
import { DateRenderer, FloatRenderer, NumberedIndicatorRenderer, TextAlignLeftRenderer, TextAlignRightRenderer } from '../../../uiControls/SmartTableRenderers';
import ApplicationContext from '../../../ApplicationContext';
import { getTbNameByJobName, JobNames } from '../../../framework.core/JobNames';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import constants from '../../../constants';

interface AdjustBalanceStorageKeys {
  modelStorage: string,
};

interface AdjustBalanceViewParams {
  id: string | undefined,
  onPopupClose?: () => void,
  jobName: JobNames
};
interface AdjustBalanceLoadedDetailsViewParams {
  adjustBalance: IGeneralWithList,
  adjustBalanceRef: MutableRefObject<IGeneralWithList | null>,
  setAdjustBalance: (x: Partial<IGeneralWithList>) => void,
  onPopupClose?: () => void,
  jobName: JobNames
};

function getAdjustBalanceStorageKeys(): AdjustBalanceStorageKeys {
  return {modelStorage: 'report-adjust-balance'}
}

function AdjustBalanceImpl(params: AdjustBalanceViewParams) {
  const {jobName} = params;
  const {modelStorage} = getAdjustBalanceStorageKeys();
  const [inStorage, setInStorage, removeAdjustBalanceFromStorage, adjustBalanceRef] = useTypedFastStorage<IGeneralWithList>(modelStorage, null);
  const [initialized, setInitialized] = useState(false);

  
  useEffect(() => {
      initialize();
      return () => {
        removeAdjustBalanceFromStorage()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  async function loadExisting() {
    return {
    }
  }

  async function initialize() {
    if (!inStorage) {
      const data = await loadExisting();
      setInStorage({...data})
    }
    setInitialized(true);
  }

  if (!initialized || !inStorage) {
    return null;
  }

  return (
    <AdjustBalanceInitializedImpl
      adjustBalance={inStorage}
      adjustBalanceRef={adjustBalanceRef}
      setAdjustBalance={setInStorage}
      onPopupClose={params.onPopupClose}
      jobName={jobName}
    />
  );
}

function AdjustBalanceInitializedImpl({
  adjustBalance,
  adjustBalanceRef,
  setAdjustBalance,
  onPopupClose,
  jobName
}: AdjustBalanceLoadedDetailsViewParams) {
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [check, setCheck] = useState(true);
  const appContext = useContext(ApplicationContext);
    const [statusMsg, setStatusMsg] = useState('There is no data.');
  function onChange(change: Partial<IGeneralWithList>) {
    setAdjustBalance(change);
  }

  const tableOptions: ApplicableTableSettings = {
    tableName: 'adjustBalanceTable',
    ...adjustBalanceTable,
    data: adjustBalance.list,
    
    rowRenderers: [
      {accessor: 'indicator', Cell: NumberedIndicatorRenderer},
      {accessor: 'id',  Cell: TextAlignRightRenderer},
      {accessor: 'invoiceDate', Cell: DateRenderer },
      {accessor: 'invoiceNo',  Cell: TextAlignLeftRenderer},
      {accessor: 'hdInvAmt',  Cell: FloatRenderer},
      {accessor: 'hdDutyAmt',  Cell: FloatRenderer},
      {accessor: 'hdPaidAmt',  Cell: FloatRenderer},
      {accessor: 'hdDutyPaidAmt',  Cell: FloatRenderer},
      {accessor: 'dtInvAmt',  Cell: FloatRenderer},
      {accessor: 'dtDutyAmt',  Cell: FloatRenderer},
      {accessor: 'rPaidAmt',  Cell: FloatRenderer},
      {accessor: 'rDutyPaidAmt',  Cell: FloatRenderer},

    ],
    getCustomCellProps: (currentProps: any, cell: any, rowIndex: any) => {
      const row = cell.row.original;
      const colId = cell.column.id;

      // BackColor 설정
      if (['hdInvAmt', 'hdDutyAmt', 'hdPaidAmt', 'hdDutyPaidAmt'].includes(colId)) {
        currentProps.style.backgroundColor = 'rgb(214, 239, 137)';
      } else if (['dtInvAmt', 'dtDutyAmt'].includes(colId)) {
        currentProps.style.backgroundColor = 'rgb(128, 255, 255)';
      } else if (['rPaidAmt', 'rDutyPaidAmt'].includes(colId)) {
        currentProps.style.backgroundColor = 'rgb(255, 255, 128)';
      }

      // ForeColor 설정 (값 비교)
      if (colId === 'hdInvAmt' && Math.abs(row.hdInvAmt - row.dtInvAmt) > 0.001) {
        currentProps.style.color = 'red';
        currentProps.style.fontWeight = 'bold';
      }
      if (colId === 'hdDutyAmt' && Math.abs(row.hdDutyAmt - row.dtDutyAmt) > 0.001) {
        currentProps.style.color = 'red';
        currentProps.style.fontWeight = 'bold';
      }
      if (colId === 'hdPaidAmt' && Math.abs(row.hdPaidAmt - row.rPaidAmt) > 0.001) {
        currentProps.style.color = 'red';
        currentProps.style.fontWeight = 'bold';
      }
      if (colId === 'hdDutyPaidAmt' && Math.abs(row.hdDutyPaidAmt - row.rDutyPaidAmt) > 0.001) {
        currentProps.style.color = 'red';
        currentProps.style.fontWeight = 'bold';
      }

      return currentProps;
    },
    // footerRow: [ 
    //    {
    //      colspan:9,
    //      renderer:TotalAmountRenderer
    //    }
    // ],
    height: '420px',
    
  }; 
  
//  function TotalAmountRenderer() {
//     let totalErrorAmt = 0;
//     if(adjustBalance?.list){
//       totalErrorAmt = adjustBalance.list.map(x => x.errorAmt).reduce((acc: number, x) => acc + x , 0)
//       return <Float decimals={2} style={{color: 'blue', textAlign:'left',  backgroundColor: 'white'}} disabled value={totalErrorAmt} />; 
//     }
//     else {
//       return <Float decimals={2} disabled value={null} />; 
//     }  
//   }

  async function subFill(){
    const apiResult = await appContext.api.subFill(getTbNameByJobName(jobName),getAdjTypeByJobName(jobName));
    if(apiResult && apiResult.success){
      if(apiResult.result.length > 0){
        setCheck(false);
        onChange({list: apiResult.result})
        
      }
      else{
        setCheck(true);
        setStatusMsg('There is no data.');
         //await showGlobalOkDialog("No Error Account List");
      }

       setStatusMsg(`${apiResult.result.length} invalid data was found.`);
    }
    else{
       setStatusMsg('There is no data.');
      await showGlobalOkDialog(apiResult?.message ?? constants.LOAD_ERROR_MESSAGE);
    }
  }

  async function subUpdate(){

    const count = adjustBalance.list.length;

    if (count <= 0) return;

    

    const adjType = getAdjTypeByJobName(jobName);
    const invAmtField = adjType === 'AdjustCrDb' ? 'F_Total' : 'F_InvoiceAmt';
    const hasLAmt = adjType !== 'AdjustCrDb';

     setStatusMsg('Working...');

    const apiResult = await appContext.api.subUpdate( adjustBalance.list, invAmtField, hasLAmt);
    if(!apiResult || !apiResult.success){
      await showGlobalOkDialog(apiResult?.message ?? constants.LOAD_ERROR_MESSAGE);
    } else{
       setStatusMsg(`You have recovered ${count} invalid data.`);
      onChange({list:[]})
      setCheck(true);
    }
  }

  function getAdjTypeByJobName(jobName: string){
    switch(jobName){
        case JobNames.Invoice:                  
        case JobNames.InvoAdj:                                     
        case JobNames.AutoBillingStorage:       
        case JobNames.AutoBillingInvoice:               return "AdjustInvo";

        case JobNames.GInvo:                            return "AdjustGInvo";

        case JobNames.Bill:                             return "AdjustAP";

        case JobNames.GBill:                            return 'AdjustGAP';

        case JobNames.WHStorageInv:                     return 'AdjustStorage';
        case JobNames.CrDb:                             return 'AdjustCrDb';

        default : return '';
    }
  }

  return (
    <div className='report-popup'>
      <div>
        <SmartTable {...tableOptions} />
      </div>

     <div className='report-footer' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <span style={{ alignSelf: 'center', paddingLeft: '40px' , fontSize: '16px' }}>
    {statusMsg}
  </span>
  
  <div style={{ display: 'flex', gap: '45px', paddingRight: '38px'  }}>
    <SecondaryButton
      size="regular"
      style={{width: '100px'}}
      onClick={subFill}
    >
      READ ERROR
    </SecondaryButton>
    <SecondaryButton
      size="regular"
      style={{width: '90px'}}
      hidden={check}
      onClick={subUpdate}
    >
      UPDATE
    </SecondaryButton>
    <SecondaryButton
      size="regular"
      style={{width: '90px'}}
      onClick={onPopupClose}>
      CLOSE
    </SecondaryButton>
  </div>
</div>
    </div>
  );
}

const AdjustBalance = ({
  onPopupClose, 
  jobName
}: {
  onPopupClose?: () => void, jobName : JobNames
}) => {
  // const { id } = useParams<AdjustBalanceViewParams>();

  return (
    <AdjustBalanceImpl id={''} jobName={jobName} onPopupClose={onPopupClose} key={`adjustBalance-details`} />
  );
};
export default AdjustBalance;
